import { ENV_VARS } from 'constants/environment.constants';
import { useEffect } from 'react';

const RedirectToLoginPage = () => {
  useEffect(() => {
    /** Automatically navigate to an external URL when the component renders */
    window.location.href = ENV_VARS?.KF_TALENT_SUITE;
  }, []);

  return null;
};

export default RedirectToLoginPage;
